import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import React, { useEffect, useState, useCallback } from "react";
import TransactionHistory from "../../features/manageUsers/transctionHistory";
import { useLazyGetTransactionsQuery } from "../../service/transactions";
import Pagination from "../../components/Panigation";

const TableHeader = ({
  setSearchTerm,
  searchTerm,
}: {
  setSearchTerm: (value: string) => void;
  searchTerm: string;
}) => {
  return (
    <div className="table_header">
      <div className="left_s">
        <SearchBar
          searchTerm={searchTerm}
          setDebouncedSearchTerm={setSearchTerm}
          placeholder="Search..."
        />
      </div>
    </div>
  );
};

const ManagePayments = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [transactionsData, setTransactionsData] = useState<any>([]);
  const [getTransactions] = useLazyGetTransactionsQuery();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const totalPages = Math.ceil(totalCount / limit);

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  // Fetch data when debounced search term, page, or limit changes
  useEffect(() => {
    handleGetTransactions();
  }, [debouncedSearchTerm, page, limit]);

  const handleGetTransactions = useCallback(async () => {
    try {
      const response = await getTransactions({
        page: page,
        limit: limit,
        search: debouncedSearchTerm,
      }).unwrap();

      if (response?.status) {
        setTransactionsData(response?.data?.list);
        setTotalCount(response?.data?.totalCount || 0);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  }, [page, limit, debouncedSearchTerm, getTransactions]);
  // ...

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    handleGetTransactions();
  };
  return (
    <>
      <div className="main_title">
        <h1>Manage Payments</h1>
        <p>
          <button
            onClick={() => navigate("/dashboard")}
            className="btn btn_primary"
          >
            Dashboard
          </button>{" "}
          - Manage Payments
        </p>
      </div>

      <div className="cards">
        <TableHeader setSearchTerm={setSearchTerm} searchTerm={searchTerm} />
        <TransactionHistory transactionsData={transactionsData} />
        {totalCount > 0 && (
          <Pagination
            module={transactionsData}
            page={page}
            onPageChange={handlePageChange}
            totalPages={totalPages}
            setPage={setPage}
            totalCount={totalCount}
          />
        )}
      </div>
    </>
  );
};

export default ManagePayments;
